import React from "react";
import { useMediaQuery } from "@mui/material";

import { useTheme } from "@mui/material/styles";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { enZA } from "date-fns/locale/en-ZA";
import { useState } from "react";

const DateAdapter = ({ input, meta, label, ...rest }) => {
  const theme = useTheme();
  const lessThanMD = useMediaQuery(theme.breakpoints.down("md"));
  const readOnly = rest.readonly;
  const [errorMessage, setErrorMessage] = useState("");
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={enZA}>
        <DatePicker
          {...rest}
          views={["year", "month", "day"]}
          label={label}
          required={true}
          onError={(newError) => {
            if (newError === "minDate") {
              setErrorMessage(
                `Date must be on or after ${new Date(
                  rest.minDate
                ).toLocaleDateString("en-ZA")}`
              );
            } else if (newError === "maxDate") {
              setErrorMessage(
                `Date must be on or before ${new Date(
                  rest.maxDate
                ).toLocaleDateString("en-ZA")}`
              );
            } else {
              setErrorMessage(newError?.trim() ?? "");
            }
          }}
          value={input.value}
          openTo="year"
          format="yyyy/MM/dd"
          slotProps={{
            textField: {
              size: "small",
              margin: "dense",
              readOnly: readOnly || !lessThanMD,
              error:
                !rest.disabled &&
                (errorMessage !== "" || (meta.touched && meta.error)),
              onBlur: input.onBlur,
              onOpen: input.onFocus,
              onClose: input.onBlur,
              helperText:
                meta.touched && meta.error && errorMessage !== ""
                  ? meta.error + " & " + errorMessage
                  : meta.touched && meta.error
                    ? meta.error
                    : errorMessage,
            },
          }}
          margin="dense"
          onChange={(value) => {
            if (value === null || value === "" || value === undefined) {
              return input.onChange(null);
            } else {
              return input.onChange(value);
            }
          }}
        />
      </LocalizationProvider>
    </>
  );
};

export default DateAdapter;
